import {confidence, Confidence} from "./confidence/TradingIdeasConfidenceComponent";
import {tradingIdeasReward, TradingIdeasRisk} from "./risk/TradingIdeasRiskComponent";

import Payoff from "./payoff";
import {IdeaInfoDialogService} from "./info/services/IdeaInfoDialogService";
import {
    ironCondorIdeaInfoDialog,
    IronCondorIdeaInfoDialog
} from "./info/iron-condor/dialog/IronCondorIdeaInfoDialogComponent";
import {TradingIdeasEditControl, tradingIdeasEditControl} from "./controls/edit/TradingIdeasEditControlComponent";
import {
    tradingIdeasPreviousControl,
    TradingIdeasPreviousControl
} from "./controls/previous/TradingIdeasPreviousControlComponent";
import {TradingIdeasNextControl, tradingIdeasNextControl} from "./controls/next/TradingIdeasNextControlComponent";
import {tradingIdeasPlaceControl, TradingIdeasPlaceControl} from "./controls/place/TradingIdeasPlaceControlComponent";
import {tradingIdeaTargetPrice, TradingIdeaTargetPrice} from "./info/target-price/TargetPriceComponent";

export default function(parentDir: string): string {

    const rootDir = `${parentDir}/elements`;

    return angular.module("tfApp.trading-ideas.elements", [Payoff(rootDir)])
                  .component(TradingIdeasNextControl, tradingIdeasNextControl(rootDir))
                  .component(TradingIdeasPreviousControl, tradingIdeasPreviousControl(rootDir))
                  .component(TradingIdeasEditControl, tradingIdeasEditControl(rootDir))
                  .component(TradingIdeasPlaceControl, tradingIdeasPlaceControl(rootDir))
                  .component(Confidence, confidence(rootDir))
                  .component(TradingIdeasRisk, tradingIdeasReward(rootDir))
                  .component(TradingIdeaTargetPrice, tradingIdeaTargetPrice())
                  .service(IdeaInfoDialogService.id, IdeaInfoDialogService)
                  .component(IronCondorIdeaInfoDialog, ironCondorIdeaInfoDialog(rootDir))
        .name;
}
